import React, { useEffect, useState /* useEffect */ } from "react";
import { useSelector } from "react-redux";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { CUInputGroup } from "./CUInputGroup";
import { FormGroup, Typography } from "@mui/material";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import { toast } from "react-toastify";
//import CoreSelect from "../../../app/core/components/CoreSelect/CoreSelect";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  useDeleteDocumentMutation,
  useDoCheckDuplicateMutation,
  useEditDocumentMutation,
  useGetSingleDocumentIdQuery,
  useRejectDocumentMutation,
  useValidateDocumentMutation,
} from "../../api/admin/gestisciDocumentiApi";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreDuplicate from "../../../app/core/components/CoreDuplicate.jsx/CoreDuplicate";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { useTranslation } from "react-i18next";
import { validateFiscalCode } from "../../../utils/functions/form";
import CoreMaxCharacter from "../../../app/core/components/CoreMaxCharacter/CoreMaxCharacter";

const CUFormContainer = ({
  extractedDocument,
  document,
  subCategoryId,
  mainCategoryId,
  closeModal,
  typeButton,
  nextDocument,
  handleOpenDiscardDialog,
  handleChangeStatusDoc,
  userIsDichCongiunta,
  fiscalCodes,
}) => {
  const { t } = useTranslation();
  const cuForm = useSelector((state) => state.singleDocument.cu);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [duplicate, setDuplicate] = useState("");
  const [open, setOpen] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [CFMessage, setCFMessage] = useState({
    text: "",
    positive: false,
    alert: false,
  });

  const [validateDocument, { isLoading: isValidateLoading }] =
    useValidateDocumentMutation();
  const [doCheckDuplicate, { isLoading: isDuplicateLoading }] =
    useDoCheckDuplicateMutation();
  const [editDocument, { isLoading: isEditLoading }] =
    useEditDocumentMutation();
  const [rejectDocument, { isLoading: isRejectLoading }] =
    useRejectDocumentMutation();

  const { data, isLoading } = useGetSingleDocumentIdQuery(duplicate, {
    skip: !duplicate,
  });
  const [deleteDocument, { isLoading: isDeleting }] =
    useDeleteDocumentMutation();

  useEffect(() => {
    setFormData({
      OperatorNotes: document.operatorNotes || "",
      Notes: document.notes || "",
      Name: document.name || "",
      extractedDocument: extractedDocument,
    });
    const message = validateFiscalCode(
      document?.cu?.codiceFiscale,
      document,
      fiscalCodes,
      userIsDichCongiunta
    );
    if (message.alert) setCFMessage(message);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document, document.id, fiscalCodes, extractedDocument]);

  const confirmDelete = () => {
    deleteDocument(document.id)
      .then((res) => {
        if (res.data.Result === 1) {
          toast.success(t("DocDeleted"));
          setOpenDeleteDialog(false);
          closeModal();
        } else {
          toast.error(t("DocNotDeleted"));
        }
      })
      .catch((err) => toast.error(err));
  };

  const handleDelete = () => {
    handleOpenDeleteDialog();
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenDeleteDialog = () => {
    setOpenDeleteDialog(true);
  };
  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEdit = () => {
    const bodyData = {
      id: document.id,
      Name: formData.Name,
      MainCategoryId: mainCategoryId,
      CategoryId: subCategoryId,
      Ownership: formData.ownership,
      Scope: document.Scope,
      notes: document.notes || "",
      OperatorNotes: formData.OperatorNotes,
      Cu: cuForm,
      Status: document.Status,
    };

    editDocument(bodyData)
      .unwrap()
      .then((data) => {
        if (data.Result === 1) {
          toast.success(t("DocEdited"));
          closeModal();
        } else {
          toast.error(data.Exception);
        }
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const bodyData = {
      id: document.id,
      Name: formData.Name,
      MainCategoryId: mainCategoryId,
      CategoryId: subCategoryId,
      Ownership: formData.ownership,
      Scope: document.Scope,
      Notes: document.notes || "",
      OperatorNotes: formData.OperatorNotes,
      Cu: cuForm,
    };

    const bodyDuplicate = {
      cU_Nome: cuForm.nome,
      cU_Cognome: cuForm.cognome,
      cU_CodiceFiscale: cuForm.codiceFiscale,
      cU_AnnoRiferimento: cuForm.annoRiferimento,
      categoryId: subCategoryId,
      userId: document.userId,
    };

    doCheckDuplicate(bodyDuplicate).then((res) => {
      if (res.data.Data !== null) {
        toast.info(t("DocDuplicated"));
        setDuplicate(res.data.Data);
        handleOpen();
      } else {
        validateDocument(bodyData)
          .unwrap()
          .then((data) => {
            if (data.Result === 1) {
              toast.success(t("DocValidated"));
              nextDocument();
            } else {
              toast.error(data.Exception);
            }
          });
      }
    });
  };

  return (
    <div className="flex flex-col h-full">
      <div style={{ height: "68vh" }} className=" overflow-scroll">
        {formData.extractedDocument?.fields?.find(
          (e) => e.fieldName.trim().toLowerCase() === "riassunto"
        ) && (
          <>
            <h3>Riassunto documento</h3>
            <div className="w-full max-h-32 overflow-auto rounded-md shadow-md p-4 mb-4">
              <Typography variant="body1">
                {formData.extractedDocument?.fields?.find(
                  (e) => e.fieldName.trim().toLowerCase() === "riassunto"
                )?.value?.String ||
                  formData.extractedDocument?.fields?.find(
                    (e) => e.fieldName.trim().toLowerCase() === "riassunto"
                  )?.value}
              </Typography>
            </div>
          </>
        )}

        <CoreInputField
          className="w-full"
          name="Name"
          label={t("Name") + " " + t("document")}
          value={formData.Name}
          onChange={handleChange}
        />
        <CUInputGroup
          document={document}
          subCategoryId={subCategoryId}
          CFMessage={CFMessage}
          fiscalCodes={fiscalCodes}
          userIsDichCongiunta={userIsDichCongiunta}
          setCFMessage={setCFMessage}
        />
        <div className="flex flex-col">
          {document.status === 6 ? (
            <div className="py-4 flex flex-col">
              <CoreTextArea
                disabled
                rows={5}
                label={t("DiscardNotes")}
                name="notesDiscard"
                value={document.rejectionNotes}
              />
            </div>
          ) : (
            <div className="flex gap-4 items-center">
              <FormGroup className="w-full my-5 italic">
                <CoreTextArea
                  disabled
                  rows={5}
                  label={t("UserNotes")}
                  value={document.notes || t("NoOne")}
                />
              </FormGroup>
              <FormGroup className="w-full my-5">
                <CoreTextArea
                  rows={5}
                  label={t("OperatorNotes")}
                  name="OperatorNotes"
                  value={formData.OperatorNotes}
                  onChange={handleChange}
                  error={formData.OperatorNotes?.length > 500}
                />
              </FormGroup>
              <CoreMaxCharacter
                maxCharacter={500}
                text={formData.OperatorNotes}
              />
            </div>
          )}
        </div>
      </div>
      <div
        style={{ borderTop: "1px solid lightgrey" }}
        className="h-24 flex justify-around pt-6 items-center"
      >
        <CoreButton
          onClick={handleDelete}
          testo={t("Delete")}
          className="btn-round bg-red-700 text-white border-red-700"
        />
        {document.status !== 6 && (
          <CoreButton
            onClick={handleOpenDiscardDialog}
            testo={t("Discard")}
            className="btn-round-outline border-orange-400 text-orange-400"
          />
        )}
        {typeButton === t("Save") ? (
          <CoreButton
            className="btn-round"
            disabled={isEditLoading || formData.OperatorNotes?.length > 500}
            testo={document.status === 6 ? t("Recover") : t("Save")}
            onClick={
              document.status === 6
                ? () => handleChangeStatusDoc(document)
                : handleEdit
            }
          />
        ) : (
          <CoreButton
            onClick={handleSubmit}
            className="btn-round"
            disabled={isValidateLoading || isDuplicateLoading}
            disabledclassnames="btn-disabled"
          >
            {typeButton}
          </CoreButton>
        )}
      </div>

      <CoreModal
        width={350}
        height={300}
        state={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        component={
          <div className="text-center">
            {/* Icona di punto esclamativo centrata */}
            <div className="text-4xl mb-2">
              <ErrorOutlineIcon
                className="text-red-700"
                sx={{ fontSize: 70 }}
              />
            </div>

            {/* Testo "Sei sicuro?" centrato */}
            <div className="mb-8">Sei sicuro?</div>

            {/* Bottoni "No" e "Scarta" */}
            <div className="flex justify-between">
              <CoreButton
                className={"btn btn-round-outline"}
                variant="contained"
                testo={t("No")}
                onClick={() => setIsModalOpen(false)}
              />
              <CoreButton
                className={"btn-round"}
                variant="contained"
                testo={t("Discard")}
                disabled={isRejectLoading}
                onClick={() => {
                  rejectDocument({
                    ...document,

                    OperatorNotes: formData.OperatorNotes,
                  })
                    .then(() => {
                      setIsModalOpen(false);
                      closeModal();
                      toast.success(t("DocDiscarded"));
                    })
                    .catch((error) => {
                      toast.error(error);
                    });
                }}
              />
            </div>
          </div>
        }
      />
      <CoreModal
        width={"60%"}
        height={"95%"}
        onClose={handleClose}
        state={open}
        component={
          <>
            {isLoading ? (
              <CoreSpinner />
            ) : (
              <CoreDuplicate singleDoc={data?.Data} />
            )}
          </>
        }
      />
      <CoreDialog
        open={openDeleteDialog}
        title={t("DocDeleting")}
        content={`${t("DocDeletingConfirm")} "${formData.Name}"?`}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={confirmDelete}
        closeDialog={handleCloseDeleteDialog}
        disabledButton={isDeleting}
      />
    </div>
  );
};

export default CUFormContainer;
